// extracted by mini-css-extract-plugin
export default {"top":"HeaderVendor_top__WSCg3","box":"HeaderVendor_box__iBqsT","addButton":"HeaderVendor_addButton__zNxuB"};